import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import { Button } from "react-bootstrap";
import CustomImage from "../CustomImage";
import styles from '../../styles/pstlandingpage.module.scss'
import { useRouter } from "next/router";
import Select from "react-select";
import useZipmeLink from "../../hooks/useZipmeLink";
import { isFrappeOrJotFormClass } from "../../utils/helpers";

interface Props {
    data: any;
    jotforms: any;
    externalLink: any;
}
 
const customStyles = {
    option: (provided: any, state: any) => ({
        ...provided,
        color: state.isFocused && '#6c48f0',
        background: 'none',
        '&:hover': {
            backgroundColor: 'lightgray',
            borderRadius: '20px',
        },
    }),
};

const localeOptions = [{ label: 'Vietnamese', value: 'Vietnamese' }, { label: 'English', value: 'English' }]

const PartnerBannerSection: React.FC<Props> = ({ data, jotforms, externalLink}) => {

    const router = useRouter();
    const { zipmeLink, generateLink } = useZipmeLink();
    const handleLocaleChange = (selectedOption: any) => {
        selectedOption.value === 'Vietnamese' 
        ? router.push(router.asPath, router.asPath, { locale: 'vi-VN' }) 
        : router.push(router.asPath, router.asPath, { locale: 'en' });
    }
    
    return (
        <div className={styles.banner}>
            <Container>
            {(router.asPath.includes('recruiter/') || router.asPath.includes('franchisee/') || (router.asPath.includes('/partners/study-abroad-recruiter') && !router.asPath.includes('/partners/study-abroad-recruiter-in'))) && 
                <div className={styles.nav}>
                    <Row>
                        <Col>
                            <Nav>
                                <CustomImage src=
                                {data?.kcImageUrl || "/images/educationfair/kc_logo.svg"} width={180} height={45} alt={"kc_logo"} />
                            </Nav>
                        </Col>
                        {router.asPath.includes('vietnam') &&
                            <Col className={styles.localeButton}>
                                
                                <Select
                                    options={localeOptions}
                                    value={router.locale === 'vi-VN' ? localeOptions[0] : localeOptions[1]}
                                    className={styles.selectClass}
                                    classNamePrefix='myLocaleSelect'
                                    components={{
                                        IndicatorSeparator: () => null
                                    }}
                                    styles={customStyles}
                                    onChange={handleLocaleChange}
                                />
                            </Col>
                        }
                    </Row>
                </div>}
                
                <div className={styles.maincontent}>
                    <Row>
                        <div className="d-block d-sm-none text-center mb-4">
                            <Col xl={6} lg={6} md={12} xs={12}>
                                <div className={styles.bannerStudDiv}>
                                    <div className={styles.bg}>
                                        <CustomImage src={data?.mainImageUrl || "/images/testprep/IELTS.png"} width="350" height="350" className={styles.studImg} alt="pst" />
                                    </div>
                                </div>
                            </Col>
                        </div>
                        <Col xl={6} lg={6} md={12} xs={12}>
                            <div className={styles.fairdetails}>
                                <div className={styles.heading}>
                                    <h1>{data?.mainTitle}</h1>
                                    <p> {data?.subTitle}</p>
                                    <ul className={styles.ulli}>
                                        {
                                            data?.points?.length > 0 &&
                                            data?.points?.map((point: any) => {
                                                return (
                                                    <div style={{ color: data?.pointsColor || "#fff" }} key={point.id} className={styles.liItem}>
                                                        <CustomImage src={point?.imageUrl || "/images/starthd.png"} width={20} height={20} className={styles.img} alt={point.title} />
                                                        <span>{point.title}</span>
                                                    </div>
                                                )
                                            })
                                        }

                                    </ul>
                                </div>
                                <div className={styles.regBtn}>
                                    <Button onClick={() => {
                                        !jotforms[0]?.jotformid && generateLink(externalLink)
                                    }}
                                        className={`${styles.btnReg}${jotforms[0]?.jotformid
                                            ? ` ${isFrappeOrJotFormClass(jotforms[0]?.jotformid)}`
                                            : ''
                                            }`}
                                    >
                                        { data.button?.[0]?.label || 'Enquire Now' }
                                    </Button>
                                        {(jotforms.length > 1) && (<Button className={`${styles.enq} ${isFrappeOrJotFormClass(jotforms[1]?.jotformid)}`}>
                                        { data.button?.[1]?.label || 'Register Now' }
                                    </Button>)}
                                </div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={12} xs={12}>
                            <div className="d-none d-sm-block text-center mb-4">
                                <div className={styles.bannerStudDiv}>
                                    <div className={styles.bg}>
                                        <CustomImage src={data?.mainImageUrl || "/images/testprep/IELTS.png"} width={450} height={450} className={styles.studImg} alt="location.png" />
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>

                </div>
            </Container >
        </div >
    )
}
export default PartnerBannerSection;